import { BRAND } from '../../shared/theme/paletteDark';
import { FONTS } from '../../shared/theme/typography';

/** Outlined text fields on the dark forms: personal events and event edits. */
export const fieldSx = {
  '& .MuiOutlinedInput-root': {
    color: BRAND.parchment,
    fontFamily: FONTS.body,
    fontSize: 14,
    '& fieldset': { borderColor: 'rgba(243,238,231,0.3)' },
    '&:hover fieldset': { borderColor: 'rgba(243,238,231,0.5)' },
    '&.Mui-focused fieldset': { borderColor: BRAND.parchment },
  },
  '& .MuiInputLabel-root': { color: 'rgba(243,238,231,0.6)', fontFamily: FONTS.body, fontSize: 14 },
  '& .MuiInputLabel-root.Mui-focused': { color: BRAND.parchment },
  '& .MuiOutlinedInput-input::placeholder': { opacity: 0.5 },
  '& .MuiFormHelperText-root': { fontFamily: FONTS.body, fontSize: 11.5, marginLeft: 0 },
} as const;
